import { PolygonWallOpeningSpanType } from 'utils/space-polygon-wall-opening-types';
import { getPolygonWallOpeningDrawn } from 'utils/space-polygon-wall-opening-visuals';

type SpacePolygonWallOpeningsProps = {
  openings: PolygonWallOpeningSpanType[];
};

export default function SpacePolygonWallOpenings({
  openings
}: SpacePolygonWallOpeningsProps) {
  return (
    <g aria-hidden='true' style={{ pointerEvents: 'none' }}>
      {openings.map((opening) => {
        const drawn = getPolygonWallOpeningDrawn(opening);
        return (
          <g key={drawn.id} data-polygon-opening={drawn.type}>
            <line
              x1={drawn.bar.p1.x}
              y1={drawn.bar.p1.y}
              x2={drawn.bar.p2.x}
              y2={drawn.bar.p2.y}
              stroke={drawn.bar.color}
              strokeWidth={drawn.bar.strokeWidth}
              strokeLinecap='square'
            />
          </g>
        );
      })}
    </g>
  );
}
